import { useAuthStore } from "@/stores/authStore";

/**
 * The active Branch ▸ Section, as a cache key fragment.
 *
 * Every scoped query must carry this. The scope travels to the server in a
 * header rather than in the URL, so two requests for "the stock overview" under
 * two different counters are indistinguishable to React Query — it serves the
 * first one's answer for the second, and the screen keeps showing the previous
 * counter's figures while the top bar insists you changed it.
 *
 * That is exactly what happened: the selector was fixed to narrow properly, the
 * header went out correctly, the server answered correctly, and the interface
 * displayed a cached reply to a question it had asked under a different scope.
 */
export function useScopeKey(): string {
  return useAuthStore((s) => s.session?.activeSectionId ?? "all");
}
